// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"e3e02715","545":"b3ba8a86"}[chunkId] + ".chunk.js";
};